import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { SxProps } from "@mui/system"
import NextImage from "@src/components/NextImage"
import NextLink from "@src/components/NextLink"
import { ROUTES } from "@src/constants/routes"
import type { Collection } from "@src/types/collection"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
import relativeTime from "dayjs/plugin/relativeTime"
import Link from "next/link"
import LikeIcon from "./LikeIcon"


dayjs.extend(duration)
dayjs.extend(relativeTime)

interface Props {
  data: Collection
  sx?: SxProps
}

function CollectionCard({ data, sx = {} }: Props) {
  const { id, name, thumbnail, created_at, slug, type } = data || {}

  return (
    <Stack
      direction={"column"}
      sx={{
        padding: "16px",
        borderRadius: "16px",
        backgroundColor: "#fff",
        "&:hover": {
          boxShadow: "0 10px 40px -4px rgba(0, 0, 0, .16)"
        },
        ...sx
      }}
    >
      <Link href={`${ROUTES.COLLECTION}/${slug}`}>
        <NextImage
          className="zoom-in flashing"
          src={thumbnail || "/assets/images/no-image.png"}
          sx={{
            overflow: "hidden",
            borderRadius: "16px",
            aspectRatio: "4/3",
            "& .next-image-full": {
              borderRadius: "16px",
              height: "auto !important"
            }
          }}
        />
      </Link>

      <NextLink
        sx={{
          fontSize: "24px",
          lineHeight: "32px",
          fontWeight: 700,
          marginY: "16px",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap"
        }}
        href={`${ROUTES.COLLECTION}/${slug}`}
      >
        {name}
      </NextLink>
      <Typography
        sx={{
          fontSize: "12px",
          lineHeight: "18px"
        }}
      >
        {created_at}
      </Typography>
      <Stack
        sx={{
          height: "40px"
        }}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 700,
            color: "#808080"
          }}
        >
          {`#${type}`}
        </Typography>
        <LikeIcon collectionId={id} slug={slug} />
      </Stack>
    </Stack>
  )
}

export default CollectionCard
